/**
 * Runtime entry for Apache ECharts.
 *
 * The package ships `export =` (CJS/UMD). A default ESM import type-checks with
 * `esModuleInterop` but esbuild rejects it ("No matching export for import default").
 * Namespace imports fail under NodeNext. `import = require` works for both.
 */
// eslint-disable-next-line @typescript-eslint/no-require-imports -- echarts CJS interop
import echarts = require('echarts');

export default echarts;
